module.exports = __webpack_public_path__ + "static/media/intro.3dce69c1.mp3";